import React, { useContext, useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import Header from '../header/Header'
import './index.css'
import parse from 'html-react-parser';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { deleteTemplate, getRejectedTemplates, getTemplates } from '../../redux/features/template/templateSlice';
import useToast from '../../shared/Toast';
import AppContext from '../../storage/AppContext';
import * as constants from '../../config/config'
import {MdRefresh} from "react-icons/md"


const Templates = () => {

  const [templates,setTemplates] = useState([])
  const [templateType, setTemplateType] = useState(constants.approved)

  const templateDetails = useSelector(state => state.template.getTemplateDetails)
  const rejectedTemplateDetails = useSelector(state => state.template.getRejectedTemplateDetails)
  const deleteTemplateDetails = useSelector(state => state.template.deleteTemplateDetails)

  const filteredTemplates = templateType === constants.approved ? templateDetails?.data?.filter(eachTemplate => !eachTemplate.isDeleted && eachTemplate.status !== constants.pending) : rejectedTemplateDetails?.data

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const showToast = useToast();

  const appContext = useContext(AppContext);
  const userDetails = appContext?.userDetails

//   useEffect(() => {
//     dispatch(getTemplates({branch: userDetails?.data?.branch}))
//     dispatch(getRejectedTemplates({branch: userDetails?.data?.branch}))
//   },[])

  useEffect(() => {
    if(deleteTemplateDetails.status === 'succeeded'){
        setTimeout(() => {
            window.location.reload()
        }, 2500)
        showToast({ message: deleteTemplateDetails.message })
    }
    if(deleteTemplateDetails.status === "failed"){
        showToast({message: deleteTemplateDetails.message, type: 'error'})
    }
  },[deleteTemplateDetails])

  const onClickAddTemplate = () => {
    navigate('/saveTemplates')
  }

  const onClickEdit = (eachTemplate) => {
    navigate('/editTemplates',{ state: eachTemplate })
  }

  const onClickDelete = (eachTemplate) => {
    dispatch(deleteTemplate(eachTemplate))
  }

  const onClickRefresh = () => {
    const branch = userDetails?.data?.branch
    dispatch(getTemplates({branch}))
    dispatch(getRejectedTemplates({branch}))
  }

  return (
    <>
    <Header />
    <div className='d-flex flex-column mt-2'>
        <div className='d-flex justify-content-between mt-2 mb-2 px-5'>
            <div>
            <button className='btn btn-info mr-2' onClick={() => setTemplateType(constants.approved)}>Approved Templates</button>
            <button className='btn btn-info' onClick={() => setTemplateType(constants.rejected)}>Rejected Templates</button>
            </div>
            <div>
            <button className='btn btn-primary align-self-end mr-4' onClick={onClickAddTemplate}> Add Template</button>
            <button className='btn btn-dark mr-2' onClick={() => {onClickRefresh()}}><MdRefresh size={24} className='pb-1'/> Refresh</button>
            </div>
        </div>
        {(rejectedTemplateDetails.status === 'loading' || templateDetails.status === 'loading' || deleteTemplateDetails.status === 'loading') ? (<div style={{ minHeight: '80vh' }} className='d-flex justify-content-center align-items-center'><Spinner animation="border" role="status"></Spinner></div>) :
            <>
            {filteredTemplates?.length === 0 ? <h1 className='text-center mt-5'>No Templates Found</h1>: 
                <div className='px-5 d-flex flex-column mt-2'>
                    {filteredTemplates?.map((eachTemplate,i) => {
                            return(
                                <div key={i} className='d-flex align-items-center'>
                                    <div className='template-card d-flex flex-column'>
                                        <h5>{eachTemplate.title}</h5>
                                        <span >{parse(eachTemplate.message)}</span>
                                    {eachTemplate.status !== constants.rejected && <div className='align-self-end'>
                                        <button className='btn btn-warning ml-2 mr-2' onClick={() => {onClickEdit(eachTemplate)}}>Edit</button>
                                        {userDetails?.data?.role === 'Admin' && <button className='btn btn-danger' onClick={() => {onClickDelete(eachTemplate)}}>Delete</button>}
                                    </div>}
                                    </div>
                                </div>
                            )
                    })}
                </div>}
        </>}
    </div>
    </>
  )
}

export default Templates